import { lazy } from "react";

const ListAudioPage = lazy(() => import("./main"));

const UpdateAudioPage = lazy(() => import("./update"));

const ViewAudioPage = lazy(() => import("./view"));

export { ListAudioPage, UpdateAudioPage, ViewAudioPage };
